import { bool, func, shape, string } from "prop-types"
import { DatePicker } from "components/ui"
import { Button } from "@planningcenter/tapestry-react"
import TimePicker from "components/ui/TimePicker"
import moment from "moment-timezone"
import { css } from "@emotion/core"

const styles = {
  dateTimePicker: css`
    & input {
      height: 32px;
      padding: 6px;
      @media (min-width: 720px) {
        max-width: 112px;
      }
    }
  `
}

const DateTimePicker = ({ datetime, isMobile, onChange, onButtonClick, errors }) => {
  return (
    <div className="pl-3 mt-1 d-f">
      <div className="pr-1" css={styles.dateTimePicker}>
        <DatePicker
          onChange={onChange}
          classNames={`date-picker ${errors.date ? "error-input" : null}`}
          datetime={datetime}
        />
      </div>
      <div className="pl-1 mr-1" css={styles.dateTimePicker}>
        <TimePicker
          classNames={`select time-picker ${errors.time ? "error-input" : null}`}
          onChange={onChange}
          datetime={datetime}
          twentyFourHourTime={App.currentOrganization.twentyFourHourTime}
          mobileBrowser={isMobile}
        />
      </div>
      <Button
        title="Save"
        theme="create"
        size="sm"
        onClick={onButtonClick}
        disabled={!moment(datetime).isValid()}
      />
    </div>
  )
}

DateTimePicker.propTypes = {
  datetime: string,
  isMobile: bool,
  onChange: func,
  onButtonClick: func,
  errors: shape({
    date: string,
    time: string
  })
}

export default DateTimePicker
